import React  from 'react';
import ReaderTableApp from "../Functionality/ReaderTableApp";
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import {TrashOutlineIcon} from "../../../../../components/buttons/IconButtons";
import {ButtonLargeTransparent} from "../../../../../components/buttons/ButtonLargeTransparent";
import CreateReaderModal from "../../Readers/Modal/CreateReaderModal";
import DeleteModal from "../../../../Modals/DeleteModal";
import CustomTable from "../../../../../components/table/CustomTable";
import DividerWithText from "../../../../../components/DividerWithText";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer -cir IBL
 * @Email: kpozos@ibl.mx
 */
const ReaderTable = ({defaultSioList}) => {
    const {
        t,
        id,
        thead,
        tbody,
        tableId,
        selectedList,
        showCreateReaderModal,
        setShowCreateReaderModal,
        deleteReaderShow,
        setDeleteReaderShow,
        isAllChecked,
        setModified,
        handleCheckboxChange,
        handleDeleteAll,
        deleteSelectedReader,
    } = ReaderTableApp({
        defaultSioList
    });

    return (
        <>
            <div className='row mt-4'>
                <DividerWithText title={t('readers')} />
                <div className='d-flex justify-content-end mb-2'>
                    <ButtonAction
                        id='btn_rt_delete_reader'
                        name='delete'
                        className='btn-icon-delete'
                        disabled={selectedList?.length === 0}
                        Icon={TrashOutlineIcon}
                        onClick={() => {
                            setDeleteReaderShow(true);
                        }}
                    />
                </div>
                <CustomTable
                    tableId={tableId}
                    checkbox={true}
                    checkboxTitle={"de_/_select_all"}
                    isAllChecked={isAllChecked}
                    onChangeCheckbox={handleDeleteAll}
                    handleCheckboxChange={handleCheckboxChange}
                    selectedList={selectedList}
                    thead={thead}
                    tbody={tbody}
                    columnActions={false}
                    withoutHeight={true}
                />
                <div className='my-2'>
                    <ButtonLargeTransparent
                        id="btn_rt_create_reader"
                        click={() => {
                            setShowCreateReaderModal(true);
                        }}
                        text={t("create_reader")}
                    />
                </div>
            </div>

            {showCreateReaderModal &&
                <CreateReaderModal
                    controllerId={id}
                    show={showCreateReaderModal}
                    onHide={()=> setShowCreateReaderModal(false) }
                    setModified={setModified}
                />
            }

            <DeleteModal
                show={deleteReaderShow}
                onHide={() => setDeleteReaderShow(false)}
                onClickFn={() => deleteSelectedReader()}
                data={selectedList}
                title_modal={t('delete_reader')}
                description={'are_you_sure_you_want_to_delete'}
                element_modal={'reader_s'}
            />
        </>
    );
};

export default ReaderTable;
